// src/AppRoutes.js
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
// import Login from "./Login";
// import Home from "./Home";
// import Page1 from "./Page1";
// import Page2 from "./Page2";
import ProtectedRoute from "./ProtectedRoute";

import CurrentMonthSummary from "./current-month-summary/CurrentMonthSummary";
import CurrentMonth from "./current-month/CurrentMonth";
import CurrentMonthChannel from "./current-month-channel/CurrentMonthChannel";
import FutureMonth from "./future-month/FutureMonth";
import Login from "./login";
import Scheme from "./scheme/Scheme";
import SchemeAnalysis from "./scheme-analysis/SchemeAnalysis";
import Usermaster from "./usermaster/Usermaster";
import Pricelist from "./pricelist/Pricelist";
import { getUser, checkIsAdmin } from "./helpers";
import ProductMaster from "./product-master/ProductMaster";

// PO Routes
import POHome from "./PO-Process/POHome";
import PODetails from "./PO-Process/PODetails";
import POSummary from "./PO-Process/POSummary";
import POReport from "./PO-Process/POReport";
import InvoiceRetrieval from "./Invoice-Retrieval/InvoiceRetrieval";

import VanTarget from "./van-target/VanTarget";

function AppRoutes({ onUserValidated, isUserValidated, open }) {
  const user = getUser();
  const isAdmin = checkIsAdmin();
  return (
    
    <Routes>
       <Route
        path="/"
        element={
          isUserValidated && user ? (
            <Navigate to="/current-month-summary" />
          ) : (
            <Login onUserValidated={onUserValidated} />
          )
        }
      />
    {(isAdmin === "1" || isAdmin === "0") && (
      <>
      <Route
        path="/current-month-summary" //path="/summary"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            {/* <HierarchicalTable /> */}
            <CurrentMonthSummary open={open} />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/current-month-summary"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <CurrentMonthSummary open={open} />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/current-month"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            {/* <DataTable /> */}
            <CurrentMonth open={open} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/current-month-channel"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            {/* <DataTable /> */}
            <CurrentMonthChannel open={open} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/future-month"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            {/* <DataTable /> */}
            <FutureMonth open={open} />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path='/scheme'
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <SchemeTable open={open} />
          </ProtectedRoute>
        }
      /> */}

      <Route
        path="/scheme"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <Scheme open={open} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scheme-analysis"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <SchemeAnalysis open={open} />
          </ProtectedRoute>
        }
      />

      {/* <Route
        path="/review"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <Review open={open} />
          </ProtectedRoute>
        }
      /> */}
      {/* <Route
        path='/ag-summary'
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <Summary />
          </ProtectedRoute>
        }
      />
      <Route
        path='/ag-current-month'
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <CurrentMonth />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/po-report"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <POReport open={open} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/po-summary"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <POSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/po-home"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <POHome open={open} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/po-details/:filename"
        element={
          <ProtectedRoute isUserValidated={isUserValidated}>
            <PODetails open={open} />
          </ProtectedRoute>
        }
      />
      </>
      )}
      
      {(isAdmin === "1" || isAdmin === "2") && (
        <Route
          path="/invoice-retrieval"
          element={
            <ProtectedRoute isUserValidated={isUserValidated}>
              <InvoiceRetrieval />
            </ProtectedRoute>
          }
        />
      )}
      {(!isAdmin || isAdmin === "1") && (
        <Route
          path="/usermaster"
          element={
            <ProtectedRoute isUserValidated={isUserValidated}>
              <Usermaster open={open} />
            </ProtectedRoute>
          }
        />
      )}

      {(!isAdmin || isAdmin === "1") && (
        <Route
          path="/pricelist"
          element={
            <ProtectedRoute isUserValidated={isUserValidated}>
              <Pricelist open={open} />
            </ProtectedRoute>
          }
        />
      )}

      {(!isAdmin || isAdmin === "1") && (
        <Route
          path="/product-master"
          element={
            <ProtectedRoute isUserValidated={isUserValidated}>
              <ProductMaster open={open} />
            </ProtectedRoute>
          }
        />
      )}
        <Route
          path="/van-targets"
          element={
            <ProtectedRoute isUserValidated={isUserValidated}>
              <VanTarget open={open} />
            </ProtectedRoute>
          }
        />
    </Routes>
  );
}

export default AppRoutes;
